import React from "react";
import fileImage from "../../_images/files.png";
import FileBox from "./FileBox";
import Form from "react-bootstrap/Form";

function NewFileBox(props) {

    function checkPrintable() {
        if (props.file !== undefined) {
            const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg', 'webp'];
            const linkExtension = props.file.name.split('.').pop();
            return imageExtensions.includes(linkExtension)
        }
        return false
    }

    function getImage() {
        const source = checkPrintable() ? props.src : fileImage
        return <img src={source} alt="" style={{height: "150px", width: "150px"}}/>
    }

    function getFileElement() {
        return (
            <label>{props.file.name}</label>
        )
    }

    return (
        <FileBox getImage={getImage}
                 getFileElement={getFileElement}
                 checkPrintable={checkPrintable}
                 ndx={props.ndx}
                 allowDelete={true}
                 print={props.print}
                 name={""}
                 onChange={props.onChange}
                 delete={props.delete}
                 editImage={props.editImage}
        />
    )
}

export default NewFileBox
